import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";
import ValidationError from "../validationError";
import {WorkflowType} from "../../enums/forms/workflowSteps/workflowType";
import {ErrorType} from "~/enums/ErrorType";
import CustomStatus from "../../../formability/form_builder/models/customStatus";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class WorkflowStepStatusValidator<T> extends NavigableValidator<WorkflowStep> {
  _validatorKey = 'hasValidStatus';
  defaultType = ErrorType.stepRequiresStatus;

  _validate(model: WorkflowStep): void {
    if ((!model.application_status || !CustomStatus.findByReferenceOrClientId(model.parent, model.application_status)) &&
      (model.workflow_type !== WorkflowType.certificate && model.workflow_type !== WorkflowType.licenseStatusChange)) {
      this.errors.push(this.buildValidationError(model, 'Workflow step requires a status'));
    }
  }

  buildValidationError(model: WorkflowStep, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: `${model.titleOrDefault} (step)`,
      errorNavOpts: model.validation.errorNavOpts(this, this.validatorKey, model),
      type: type || this.defaultType,
      section: this.section
    });
  }
}